import Vue from 'vue';
import Router from 'vue-router';
import Subscription from './components/Subscription.vue';
import ConfirmationPage from './components/ConfirmationPage.vue'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/confirmation',
            component: ConfirmationPage
        },
        {
            path: '/:program_code',
            component: Subscription
        }
    ]
});